import React, { useEffect, useState } from "react";
import "./HeaderNavBar.css";
import parse from "html-react-parser";
import { handleException } from "../../app/util/util";

function NotificationBar(props) {
  const userVO = JSON.parse(localStorage.getItem("userVO"));
  const keepMeLogIn = localStorage.getItem("keepLoggedIn") ? "true" : "false";
  const [state, setState] = useState({
    notificationId: null,
    notificationMessage: null,
    consolidatedNotificationList: [``],
  });

  const getSessionVO = () => {
    return {
      appType: "web",
      deviceMacId: "",
      keepMeLoggedInFlag: keepMeLogIn,
      deviceOS: localStorage.getItem("deviceOS"),
      deviceType: localStorage.getItem("deviceType"),
      browserName: localStorage.getItem("browserName"),
      sessionAuthenticationToken: userVO.sessionAuthenticationToken,
    };
  };

  useEffect(() => {
    if (navigator.onLine) {
      getNotification();
    }
  }, []);

  const getNotification = async () => {
    if (userVO) {
      var browserTime = getBrowserTime();
      let reqData = {
        userVO: {
          userId: userVO.userId,
          userRole: userVO.userRole,
          userRoleId: userVO.userRoleId,
          userActivityVO: {
            lastReadBookId: "",
            lastReadPageNum: "",
            lastReadChapterId: "",
            lastReadSectionId: "",
            lastReadParagraphId: "",
            lastViewedOutlineId: "",
            lastReadSubSectionId: "",
            lastActivityCode: "BOOKSHELF",
            pageNavigatingFrom: "EReader",
            pageNavigatingTo: "Bookshelf",
          },
          sessionVO: getSessionVO(),
        },
        notificationVO: { browserTime: browserTime },
      };
      const requestOptions1 = {
        method: "POST",
        body: JSON.stringify(reqData),
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      };
      try {
        const data = await (
          await fetch(
            `${localStorage.getItem("ENV")}/manageNotifications/getNotificationsForApplication`,
            requestOptions1,
          )
        ).json();
        if (!data) {
          return false;
        }
        if (data.status === "true" && data.notificationVOList) {
          var consolidatedNotificationList = [];
          var userTypeNotification = localStorage.getItem("userRole");
          var notificationLists = Array.isArray(data.notificationVOList)
            ? data.notificationVOList
            : [data.notificationVOList];
          var closedNotification = localStorage.getItem("closedNotification")
            ? localStorage.getItem("closedNotification")
            : "";
          var collectnotificationId = localStorage.getItem(
            "collectnotificationId",
          )
            ? localStorage.getItem("collectnotificationId")
            : null;
          if (closedNotification) {
            closedNotification = closedNotification.split(",");
          }
          for (var i = 0; i < notificationLists.length; i++) {
            if (
              notificationLists[i].displayOption == "logged in users" ||
              notificationLists[i].displayOption == "all users"
            ) {
              consolidatedNotificationList.push(notificationLists[i]);
            }
          }
          for (var i = 0; i < notificationLists.length; i++) {
            if (notificationLists[i].displayOption === userTypeNotification) {
              consolidatedNotificationList.push(notificationLists[i]);
            }
          }
          if (collectnotificationId) {
            notificationLists.forEach((element) => {
              if (element.notificationId === collectnotificationId) {
                setState({
                  ...state,
                  notificationId: element.notificationId,
                  notificationMessage: element.notificationMessage,
                  consolidatedNotificationList: consolidatedNotificationList,
                });
              }
            });
          } else {
            if (!closedNotification) {
              localStorage.setItem(
                "collectnotificationId",
                consolidatedNotificationList[0].notificationId,
              );
              setState({
                ...state,
                consolidatedNotificationList: consolidatedNotificationList,
                notificationId: consolidatedNotificationList[0].notificationId,
                notificationMessage:
                  consolidatedNotificationList[0].notificationMessage,
              });
            } else {
              var filteredNotificationVOList = getNextNotification(
                consolidatedNotificationList,
                closedNotification,
              );
              if (filteredNotificationVOList) {
                localStorage.setItem(
                  "collectnotificationId",
                  filteredNotificationVOList[0].notificationId,
                );
                setState({
                  ...state,
                  consolidatedNotificationList: consolidatedNotificationList,
                  notificationId: filteredNotificationVOList[0].notificationId,
                  notificationMessage:
                    filteredNotificationVOList[0].notificationMessage,
                });
              }
            }
          }
        } else if (data.wkErrorCode) {
          handleException(data);
        }
      } catch (error) {
        setState({ ...state, serviceCompletion: true });
      }
    }
  };

  const getBrowserTime = () => {
    var today = new Date();
    var tdate = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1;
    var yyyy = today.getFullYear();
    if (dd < 10) {
      dd = "0" + dd;
    }
    if (mm < 10) {
      mm = "0" + mm;
    }
    today = mm + "-" + dd + "-" + yyyy;
    var period = tdate.getHours() >= 12 ? "PM" : "AM";
    var hour = tdate.getHours() - (tdate.getHours() >= 12 ? 12 : 0);
    var currenthr = hour,
      currentmin = tdate.getMinutes(),
      currenttype = period;
    if (currenthr == 0) {
      currenthr = 12;
    }
    if (currentmin < 10) {
      currentmin = "0" + currentmin;
    }
    if (currenthr != 0 && currenthr < 10) {
      currenthr = "0" + currenthr;
    }
    var currentdateTime =
      today + " " + currenthr + ":" + currentmin + " " + currenttype;
    return currentdateTime;
  };

  const getNextNotification = (
    consolidatedNotificationList,
    closedNotification,
  ) => {
    var filteredNotificationVOList = [],
      flag = true;
    for (var i = 0; i < consolidatedNotificationList.length; i++) {
      flag = true;
      for (var j = 0; j < closedNotification.length; j++) {
        if (
          consolidatedNotificationList[i].notificationId ===
          closedNotification[j]
        ) {
          flag = false;
          break;
        }
      }
      if (flag) {
        filteredNotificationVOList.push(consolidatedNotificationList[i]);
      }
    }
    return filteredNotificationVOList;
  };

  const closeNotificationBar = (e) => {
    const notificationId = e.currentTarget.dataset.notificationId;
    if (notificationId) {
      var closedNotification = localStorage.getItem("closedNotification")
        ? localStorage.getItem("closedNotification").split(",")
        : [];
      closedNotification.push(notificationId);
      localStorage.setItem("closedNotification", closedNotification);
      var filteredNotificationVOList = getNextNotification(
        state.consolidatedNotificationList,
        closedNotification,
      );
      if (
        filteredNotificationVOList &&
        Array.isArray(filteredNotificationVOList) &&
        filteredNotificationVOList.length > 0
      ) {
        localStorage.setItem(
          "collectnotificationId",
          filteredNotificationVOList[0].notificationId,
        );
        setState({
          ...state,
          notificationId: filteredNotificationVOList[0].notificationId,
          notificationMessage:
            filteredNotificationVOList[0].notificationMessage,
        });
      } else {
        localStorage.removeItem("collectnotificationId");
        setState({
          ...state,
          notificationId: null,
          notificationMessage: null,
        });
      }
    } else {
      setState({
        ...state,
        notificationId: null,
        notificationMessage: null,
      });
    }
  };

  return (
    <div>
      {state.notificationMessage ? (
        <div
          id="email-notification"
          className="email-notification"
          role="status"
          aria-live="polite"
        >
          <div className="email-notification-container">
            <div
              id="notfication-header-text"
              className="email-notification-text display-inline-block messgaeNotification_rt col-lg-11  col-md-11 col-sm-11 col-xs-11"
            >
              {parse(state.notificationMessage)}
            </div>
            <div className="display-inline-block col-lg-1 col-md-1 col-sm-1 col-xs-1 no-padding hidden-xs">
              <button
                type="button"
                id="learnmore-close-notify-desktop"
                className="pull-right no-padding closeNotification_rt"
                data-notification-id={state.notificationId}
                aria-label="Close Notification"
                onClick={closeNotificationBar}
              >
                X
              </button>
            </div>
            <div className="display-inline-block no-padding visible-xs">
              <button
                type="button"
                id="learnmore-close-notify-mobile"
                className="pull-right no-padding closeNotification_rt"
                data-notification-id={state.notificationId}
                aria-label="Close Notification"
                onClick={closeNotificationBar}
              >
                X
              </button>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
}

export default NotificationBar;
